/* tslint:disable */
/* eslint-disable */
/**
 * History API (v3)
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CaseSummary
 */
export interface CaseSummary {
    /**
     * 
     * @type {string}
     * @memberof CaseSummary
     */
    'assignee'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseSummary
     */
    'status'?: CaseSummaryStatusEnum | null;
}

export const CaseSummaryStatusEnum = {
    NEEDS_REVIEW: 'needs_review',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed'
} as const;

export type CaseSummaryStatusEnum = typeof CaseSummaryStatusEnum[keyof typeof CaseSummaryStatusEnum];

/**
 * 
 * @export
 * @interface DatasetJobGenericError
 */
export interface DatasetJobGenericError {
    /**
     * 
     * @type {string}
     * @memberof DatasetJobGenericError
     */
    'message': string;
}
/**
 * Copy from flow_utils as aurora schemas package does not depend on flow_utils
 * @export
 * @enum {string}
 */

export const DecisionEnvironment = {
    LIVE: 'live',
    SANDBOX: 'sandbox',
    TEST: 'test'
} as const;

export type DecisionEnvironment = typeof DecisionEnvironment[keyof typeof DecisionEnvironment];


/**
 * Specifies a range of ordered Decision IDs (UUIDv7). Both ends are exclusive and may be omitted. If an end is omitted, the range is unbounded in that direction.
 * @export
 * @interface DecisionIdRange
 */
export interface DecisionIdRange {
    /**
     * 
     * @type {string}
     * @memberof DecisionIdRange
     */
    'after'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecisionIdRange
     */
    'before'?: string | null;
}
/**
 * 
 * @export
 * @interface DecisionList
 */
export interface DecisionList {
    /**
     * 
     * @type {Array<HistoricalDecisionApiResponse>}
     * @memberof DecisionList
     */
    'decisions': Array<HistoricalDecisionApiResponse>;
    /**
     * 
     * @type {string}
     * @memberof DecisionList
     */
    'next_page_token': string | null;
}
/**
 * 
 * @export
 * @interface DecisionMetadata
 */
export interface DecisionMetadata {
    /**
     * 
     * @type {string}
     * @memberof DecisionMetadata
     */
    'id': string;
    /**
     * 
     * @type {DecisionEnvironment}
     * @memberof DecisionMetadata
     */
    'environment': DecisionEnvironment;
    /**
     * 
     * @type {string}
     * @memberof DecisionMetadata
     */
    'status_code': string;
    /**
     * 
     * @type {ExecutionMode}
     * @memberof DecisionMetadata
     */
    'execution_mode'?: ExecutionMode | null;
    /**
     * 
     * @type {string}
     * @memberof DecisionMetadata
     */
    'flow_slug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecisionMetadata
     */
    'flow_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecisionMetadata
     */
    'flow_version_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecisionMetadata
     */
    'flow_version_etag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecisionMetadata
     */
    'job_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecisionMetadata
     */
    'job_run_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecisionMetadata
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecisionMetadata
     */
    'xray_trace_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecisionMetadata
     */
    'legacy_decision_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecisionMetadata
     */
    'source_entry_id'?: string | null;
}


/**
 * Origin type of a decision: api_call, job, or flow.
 * @export
 * @enum {string}
 */

export const DecisionOriginType = {
    API_CALL: 'api_call',
    JOB: 'job',
    FLOW: 'flow'
} as const;

export type DecisionOriginType = typeof DecisionOriginType[keyof typeof DecisionOriginType];


/**
 * Copy from flow_utils
 * @export
 * @enum {string}
 */

export const ExecutionMode = {
    SYNC: 'sync',
    ASYNC: 'async'
} as const;

export type ExecutionMode = typeof ExecutionMode[keyof typeof ExecutionMode];


/**
 * 
 * @export
 * @interface Filter
 */
export interface Filter {
    /**
     * 
     * @type {string}
     * @memberof Filter
     */
    'property': string;
    /**
     * 
     * @type {string}
     * @memberof Filter
     */
    'operator': FilterOperatorEnum;
    /**
     * 
     * @type {any}
     * @memberof Filter
     */
    'value': any;
    /**
     * 
     * @type {Array<any>}
     * @memberof Filter
     */
    'values': Array<any>;
}

export const FilterOperatorEnum = {
    IN: 'in',
    NOT_IN: 'not_in'
} as const;

export type FilterOperatorEnum = typeof FilterOperatorEnum[keyof typeof FilterOperatorEnum];

/**
 * 
 * @export
 * @interface GetDecisionsOutcomeFilter
 */
export interface GetDecisionsOutcomeFilter {
    /**
     * 
     * @type {string}
     * @memberof GetDecisionsOutcomeFilter
     */
    'outcome_type_key': string;
    /**
     * 
     * @type {Filter}
     * @memberof GetDecisionsOutcomeFilter
     */
    'filter': Filter;
}
/**
 * Base is used for both listing and creating exports. Does not include page_size, sort_by, start_end_time and end_end_time.
 * @export
 * @interface GetDecisionsParamsBaseInput
 */
export interface GetDecisionsParamsBaseInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'flow_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'flow_version_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'statuses'?: Array<GetDecisionsParamsBaseInputStatusesEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'status_codes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'job_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'job_run_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'parent_decision_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'parent_flow_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'parent_flow_version_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'environments'?: Array<GetDecisionsParamsBaseInputEnvironmentsEnum> | null;
    /**
     * 
     * @type {Array<DecisionOriginType>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'origin_types'?: Array<DecisionOriginType> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'entity_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'related_entity_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'related_schemas'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'case_status'?: Array<GetDecisionsParamsBaseInputCaseStatusEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'case_assignees'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetDecisionsParamsBaseInput
     */
    'start_start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDecisionsParamsBaseInput
     */
    'end_start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDecisionsParamsBaseInput
     */
    'starting_after'?: string | null;
    /**
     * 
     * @type {Array<GetDecisionsOutcomeFilter>}
     * @memberof GetDecisionsParamsBaseInput
     */
    'outcome_filters'?: Array<GetDecisionsOutcomeFilter> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetDecisionsParamsBaseInput
     */
    'include_intermediate_data'?: boolean;
}

export const GetDecisionsParamsBaseInputStatusesEnum = {
    SUCCESSFUL: 'successful',
    PENDING: 'pending',
    FAILED: 'failed'
} as const;

export type GetDecisionsParamsBaseInputStatusesEnum = typeof GetDecisionsParamsBaseInputStatusesEnum[keyof typeof GetDecisionsParamsBaseInputStatusesEnum];
export const GetDecisionsParamsBaseInputEnvironmentsEnum = {
    LIVE: 'live',
    SANDBOX: 'sandbox',
    TEST: 'test'
} as const;

export type GetDecisionsParamsBaseInputEnvironmentsEnum = typeof GetDecisionsParamsBaseInputEnvironmentsEnum[keyof typeof GetDecisionsParamsBaseInputEnvironmentsEnum];
export const GetDecisionsParamsBaseInputCaseStatusEnum = {
    NEEDS_REVIEW: 'needs_review',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed'
} as const;

export type GetDecisionsParamsBaseInputCaseStatusEnum = typeof GetDecisionsParamsBaseInputCaseStatusEnum[keyof typeof GetDecisionsParamsBaseInputCaseStatusEnum];

/**
 * Base is used for both listing and creating exports. Does not include page_size, sort_by, start_end_time and end_end_time.
 * @export
 * @interface GetDecisionsParamsBaseOutput
 */
export interface GetDecisionsParamsBaseOutput {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'flow_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'flow_version_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'statuses'?: Array<GetDecisionsParamsBaseOutputStatusesEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'status_codes'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'job_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'job_run_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'parent_decision_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'parent_flow_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'parent_flow_version_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'environments'?: Array<GetDecisionsParamsBaseOutputEnvironmentsEnum> | null;
    /**
     * 
     * @type {Array<DecisionOriginType>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'origin_types'?: Array<DecisionOriginType> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'entity_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'related_entity_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'related_schemas'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'case_status'?: Array<GetDecisionsParamsBaseOutputCaseStatusEnum> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'case_assignees'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'start_start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'end_start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'starting_after'?: string | null;
    /**
     * 
     * @type {Array<GetDecisionsOutcomeFilter>}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'outcome_filters'?: Array<GetDecisionsOutcomeFilter> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetDecisionsParamsBaseOutput
     */
    'include_intermediate_data'?: boolean;
}

export const GetDecisionsParamsBaseOutputStatusesEnum = {
    SUCCESSFUL: 'successful',
    PENDING: 'pending',
    FAILED: 'failed'
} as const;

export type GetDecisionsParamsBaseOutputStatusesEnum = typeof GetDecisionsParamsBaseOutputStatusesEnum[keyof typeof GetDecisionsParamsBaseOutputStatusesEnum];
export const GetDecisionsParamsBaseOutputEnvironmentsEnum = {
    LIVE: 'live',
    SANDBOX: 'sandbox',
    TEST: 'test'
} as const;

export type GetDecisionsParamsBaseOutputEnvironmentsEnum = typeof GetDecisionsParamsBaseOutputEnvironmentsEnum[keyof typeof GetDecisionsParamsBaseOutputEnvironmentsEnum];
export const GetDecisionsParamsBaseOutputCaseStatusEnum = {
    NEEDS_REVIEW: 'needs_review',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed'
} as const;

export type GetDecisionsParamsBaseOutputCaseStatusEnum = typeof GetDecisionsParamsBaseOutputCaseStatusEnum[keyof typeof GetDecisionsParamsBaseOutputCaseStatusEnum];

/**
 * 
 * @export
 * @interface GetNodeExecutionsParams
 */
export interface GetNodeExecutionsParams {
    /**
     * 
     * @type {string}
     * @memberof GetNodeExecutionsParams
     */
    'node_id': string;
    /**
     * 
     * @type {string}
     * @memberof GetNodeExecutionsParams
     */
    'job_run_id': string;
    /**
     * 
     * @type {string}
     * @memberof GetNodeExecutionsParams
     */
    'flow_id': string;
    /**
     * 
     * @type {DecisionEnvironment}
     * @memberof GetNodeExecutionsParams
     */
    'environment': DecisionEnvironment;
    /**
     * 
     * @type {TimeRange}
     * @memberof GetNodeExecutionsParams
     */
    'start_time_range': TimeRange;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetNodeExecutionsParams
     */
    'statuses'?: Array<GetNodeExecutionsParamsStatusesEnum> | null;
    /**
     * 
     * @type {DecisionIdRange}
     * @memberof GetNodeExecutionsParams
     */
    'decision_id_range'?: DecisionIdRange;
    /**
     * 
     * @type {number}
     * @memberof GetNodeExecutionsParams
     */
    'page_size'?: number;
    /**
     * 
     * @type {SortDirection}
     * @memberof GetNodeExecutionsParams
     */
    'sort_direction'?: SortDirection;
}

export const GetNodeExecutionsParamsStatusesEnum = {
    SUCCESSFUL: 'successful',
    FAILED: 'failed',
    IGNORED: 'ignored'
} as const;

export type GetNodeExecutionsParamsStatusesEnum = typeof GetNodeExecutionsParamsStatusesEnum[keyof typeof GetNodeExecutionsParamsStatusesEnum];

/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface HistoricalDecisionApiCallOrigin
 */
export interface HistoricalDecisionApiCallOrigin {
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionApiCallOrigin
     */
    'type': HistoricalDecisionApiCallOriginTypeEnum;
}

export const HistoricalDecisionApiCallOriginTypeEnum = {
    API_CALL: 'api_call'
} as const;

export type HistoricalDecisionApiCallOriginTypeEnum = typeof HistoricalDecisionApiCallOriginTypeEnum[keyof typeof HistoricalDecisionApiCallOriginTypeEnum];

/**
 * 
 * @export
 * @interface HistoricalDecisionApiResponse
 */
export interface HistoricalDecisionApiResponse {
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionApiResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionApiResponse
     */
    'entity_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionApiResponse
     */
    'grouping_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionApiResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionApiResponse
     */
    'status_code'?: string;
    /**
     * 
     * @type {DecisionEnvironment}
     * @memberof HistoricalDecisionApiResponse
     */
    'environment'?: DecisionEnvironment;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionApiResponse
     */
    'start_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionApiResponse
     */
    'end_time'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HistoricalDecisionApiResponse
     */
    'flow'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionApiResponse
     */
    'traffic_policy'?: string | null;
    /**
     * 
     * @type {Origin}
     * @memberof HistoricalDecisionApiResponse
     */
    'origin'?: Origin;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HistoricalDecisionApiResponse
     */
    'input'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HistoricalDecisionApiResponse
     */
    'output'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof HistoricalDecisionApiResponse
     */
    'child_decisions'?: Array<string> | null;
    /**
     * 
     * @type {Array<CaseSummary>}
     * @memberof HistoricalDecisionApiResponse
     */
    'cases'?: Array<CaseSummary> | null;
    /**
     * 
     * @type {Array<RelatedEntity>}
     * @memberof HistoricalDecisionApiResponse
     */
    'related_entities'?: Array<RelatedEntity> | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HistoricalDecisionApiResponse
     */
    'mock_data'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HistoricalDecisionApiResponse
     */
    'intermediate_data'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<IntegrationDuration>}
     * @memberof HistoricalDecisionApiResponse
     */
    'durations'?: Array<IntegrationDuration> | null;
}


/**
 * 
 * @export
 * @interface HistoricalDecisionExportCreate
 */
export interface HistoricalDecisionExportCreate {
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionExportCreate
     */
    'format'?: HistoricalDecisionExportCreateFormatEnum | null;
    /**
     * 
     * @type {GetDecisionsParamsBaseInput}
     * @memberof HistoricalDecisionExportCreate
     */
    'params': GetDecisionsParamsBaseInput;
}

export const HistoricalDecisionExportCreateFormatEnum = {
    JSON: 'json',
    NDJSON: 'ndjson'
} as const;

export type HistoricalDecisionExportCreateFormatEnum = typeof HistoricalDecisionExportCreateFormatEnum[keyof typeof HistoricalDecisionExportCreateFormatEnum];

/**
 * 
 * @export
 * @interface HistoricalDecisionExportResponse
 */
export interface HistoricalDecisionExportResponse {
    /**
     * 
     * @type {HistoryExportV3ResultLocation}
     * @memberof HistoricalDecisionExportResponse
     */
    'location'?: HistoryExportV3ResultLocation | null;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionExportResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionExportResponse
     */
    'format'?: HistoricalDecisionExportResponseFormatEnum | null;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionExportResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionExportResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {GetDecisionsParamsBaseOutput}
     * @memberof HistoricalDecisionExportResponse
     */
    'params': GetDecisionsParamsBaseOutput;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionExportResponse
     */
    'status': HistoricalDecisionExportResponseStatusEnum;
    /**
     * 
     * @type {DatasetJobGenericError}
     * @memberof HistoricalDecisionExportResponse
     */
    'error'?: DatasetJobGenericError | null;
}

export const HistoricalDecisionExportResponseFormatEnum = {
    JSON: 'json',
    NDJSON: 'ndjson'
} as const;

export type HistoricalDecisionExportResponseFormatEnum = typeof HistoricalDecisionExportResponseFormatEnum[keyof typeof HistoricalDecisionExportResponseFormatEnum];
export const HistoricalDecisionExportResponseStatusEnum = {
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
} as const;

export type HistoricalDecisionExportResponseStatusEnum = typeof HistoricalDecisionExportResponseStatusEnum[keyof typeof HistoricalDecisionExportResponseStatusEnum];

/**
 * 
 * @export
 * @interface HistoricalDecisionFlowOrigin
 */
export interface HistoricalDecisionFlowOrigin {
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionFlowOrigin
     */
    'type': HistoricalDecisionFlowOriginTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionFlowOrigin
     */
    'parent_decision_id': string;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionFlowOrigin
     */
    'parent_flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionFlowOrigin
     */
    'parent_flow_version_id': string;
}

export const HistoricalDecisionFlowOriginTypeEnum = {
    FLOW: 'flow'
} as const;

export type HistoricalDecisionFlowOriginTypeEnum = typeof HistoricalDecisionFlowOriginTypeEnum[keyof typeof HistoricalDecisionFlowOriginTypeEnum];

/**
 * 
 * @export
 * @interface HistoricalDecisionJobOrigin
 */
export interface HistoricalDecisionJobOrigin {
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionJobOrigin
     */
    'type': HistoricalDecisionJobOriginTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionJobOrigin
     */
    'job_id': string;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionJobOrigin
     */
    'job_run_id': string;
    /**
     * 
     * @type {string}
     * @memberof HistoricalDecisionJobOrigin
     */
    'source_entry_id'?: string | null;
}

export const HistoricalDecisionJobOriginTypeEnum = {
    JOB: 'job'
} as const;

export type HistoricalDecisionJobOriginTypeEnum = typeof HistoricalDecisionJobOriginTypeEnum[keyof typeof HistoricalDecisionJobOriginTypeEnum];

/**
 * 
 * @export
 * @interface HistoryExportV3ResultLocation
 */
export interface HistoryExportV3ResultLocation {
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3ResultLocation
     */
    'type': HistoryExportV3ResultLocationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3ResultLocation
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryExportV3ResultLocation
     */
    'expires_at': string;
}

export const HistoryExportV3ResultLocationTypeEnum = {
    S3: 's3'
} as const;

export type HistoryExportV3ResultLocationTypeEnum = typeof HistoryExportV3ResultLocationTypeEnum[keyof typeof HistoryExportV3ResultLocationTypeEnum];

/**
 * 
 * @export
 * @interface IntegrationDuration
 */
export interface IntegrationDuration {
    /**
     * 
     * @type {string}
     * @memberof IntegrationDuration
     */
    'type'?: IntegrationDurationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IntegrationDuration
     */
    'node_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IntegrationDuration
     */
    'request_id': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationDuration
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationDuration
     */
    'provider': string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationDuration
     */
    'resource': string;
    /**
     * 
     * @type {number}
     * @memberof IntegrationDuration
     */
    'provider_response_time': number;
    /**
     * 
     * @type {string}
     * @memberof IntegrationDuration
     */
    'provider_response_status': string;
    /**
     * 
     * @type {number}
     * @memberof IntegrationDuration
     */
    'request_attempts': number;
}

export const IntegrationDurationTypeEnum = {
    INTEGRATION: 'integration'
} as const;

export type IntegrationDurationTypeEnum = typeof IntegrationDurationTypeEnum[keyof typeof IntegrationDurationTypeEnum];

/**
 * 
 * @export
 * @interface ListExportResponseModel
 */
export interface ListExportResponseModel {
    /**
     * 
     * @type {Array<HistoricalDecisionExportResponse>}
     * @memberof ListExportResponseModel
     */
    'exports': Array<HistoricalDecisionExportResponse>;
    /**
     * 
     * @type {string}
     * @memberof ListExportResponseModel
     */
    'next_page_token'?: string | null;
}
/**
 * 
 * @export
 * @interface MultiOutcomeFilter
 */
export interface MultiOutcomeFilter {
    /**
     * 
     * @type {string}
     * @memberof MultiOutcomeFilter
     */
    'property': string;
    /**
     * 
     * @type {string}
     * @memberof MultiOutcomeFilter
     */
    'operator': MultiOutcomeFilterOperatorEnum;
    /**
     * 
     * @type {Array<any>}
     * @memberof MultiOutcomeFilter
     */
    'values': Array<any>;
}

export const MultiOutcomeFilterOperatorEnum = {
    IN: 'in',
    NOT_IN: 'not_in'
} as const;

export type MultiOutcomeFilterOperatorEnum = typeof MultiOutcomeFilterOperatorEnum[keyof typeof MultiOutcomeFilterOperatorEnum];

/**
 * Combines node results, tracing and metadata.
 * @export
 * @interface NodeExecutionDataExtended
 */
export interface NodeExecutionDataExtended {
    /**
     * 
     * @type {string}
     * @memberof NodeExecutionDataExtended
     */
    'node_id': string;
    /**
     * 
     * @type {string}
     * @memberof NodeExecutionDataExtended
     */
    'node_name': string;
    /**
     * 
     * @type {DecisionMetadata}
     * @memberof NodeExecutionDataExtended
     */
    'decision_metadata': DecisionMetadata;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NodeExecutionDataExtended
     */
    'data': { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NodeExecutionDataExtended
     */
    'tracing_data'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NodeExecutionDataExtended
     */
    'execution_metadata'?: { [key: string]: any; } | null;
}
/**
 * Pre-signed GET URLs for a run\'s eager node-executions, grouped by node_id.  Each node maps to a *list* because the Athena UNLOAD splits a node\'s rows across several shard files (by size), so a node may have more than one. Empty until the run\'s node-executions are fully generated.  Example:     {\"<node_id>\": [\".../node_id=<node_id>/<shard-0>.gz\",                    \".../node_id=<node_id>/<shard-1>.gz\"]}
 * @export
 * @interface NodeExecutionsFileUrls
 */
export interface NodeExecutionsFileUrls {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof NodeExecutionsFileUrls
     */
    'urls_by_node_id': { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface NodeExecutionsGenerationStatus
 */
export interface NodeExecutionsGenerationStatus {
    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsGenerationStatus
     */
    'state': string;
}
/**
 * 
 * @export
 * @interface NodeExecutionsManifest
 */
export interface NodeExecutionsManifest {
    /**
     * 
     * @type {boolean}
     * @memberof NodeExecutionsManifest
     */
    'available': boolean;
}
/**
 * 
 * @export
 * @interface NodeExecutionsPage
 */
export interface NodeExecutionsPage {
    /**
     * 
     * @type {Array<NodeExecutionDataExtended>}
     * @memberof NodeExecutionsPage
     */
    'results': Array<NodeExecutionDataExtended>;
    /**
     * 
     * @type {GetNodeExecutionsParams}
     * @memberof NodeExecutionsPage
     */
    'query_params': GetNodeExecutionsParams;
}
/**
 * 
 * @export
 * @interface NodeResultsList
 */
export interface NodeResultsList {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof NodeResultsList
     */
    'node_results': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {string}
     * @memberof NodeResultsList
     */
    'next_page_token': string | null;
}
/**
 * 
 * @export
 * @interface Origin
 */
export interface Origin {
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    'type': OriginTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    'job_id': string;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    'job_run_id': string;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    'source_entry_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    'parent_decision_id': string;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    'parent_flow_id': string;
    /**
     * 
     * @type {string}
     * @memberof Origin
     */
    'parent_flow_version_id': string;
}

export const OriginTypeEnum = {
    API_CALL: 'api_call',
    JOB: 'job',
    FLOW: 'flow'
} as const;

export type OriginTypeEnum = typeof OriginTypeEnum[keyof typeof OriginTypeEnum];

/**
 * 
 * @export
 * @interface OutcomesList
 */
export interface OutcomesList {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof OutcomesList
     */
    'outcomes': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {string}
     * @memberof OutcomesList
     */
    'next_page_token': string | null;
}
/**
 * 
 * @export
 * @interface RelatedEntity
 */
export interface RelatedEntity {
    /**
     * 
     * @type {string}
     * @memberof RelatedEntity
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RelatedEntity
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface SingleOutcomeFilter
 */
export interface SingleOutcomeFilter {
    /**
     * 
     * @type {string}
     * @memberof SingleOutcomeFilter
     */
    'property': string;
    /**
     * 
     * @type {string}
     * @memberof SingleOutcomeFilter
     */
    'operator': SingleOutcomeFilterOperatorEnum;
    /**
     * 
     * @type {any}
     * @memberof SingleOutcomeFilter
     */
    'value': any;
}

export const SingleOutcomeFilterOperatorEnum = {
    DOUBLE_EQUAL: '==',
    NOT_EQUAL: '!=',
    GREATER_THAN: '>',
    GREATER_THAN_OR_EQUAL_TO: '>=',
    LESS_THAN: '<',
    LESS_THAN_OR_EQUAL_TO: '<='
} as const;

export type SingleOutcomeFilterOperatorEnum = typeof SingleOutcomeFilterOperatorEnum[keyof typeof SingleOutcomeFilterOperatorEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirection = {
    ASC: 'asc',
    DESC: 'desc'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];


/**
 * 
 * @export
 * @interface TimeRange
 */
export interface TimeRange {
    /**
     * 
     * @type {string}
     * @memberof TimeRange
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof TimeRange
     */
    'end': string;
}
/**
 * 
 * @export
 * @interface TriggerNodeExecutionsGenerationResponse
 */
export interface TriggerNodeExecutionsGenerationResponse {
    /**
     * 
     * @type {string}
     * @memberof TriggerNodeExecutionsGenerationResponse
     */
    'query_id': string;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * DecisionsApi - axios parameter creator
 * @export
 */
export const DecisionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Expire Decision
         * @param {string} decisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireDecisionHistoryApiV3DecisionsDecisionIdDelete: async (decisionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'decisionId' is not null or undefined
            assertParamExists('expireDecisionHistoryApiV3DecisionsDecisionIdDelete', 'decisionId', decisionId)
            const localVarPath = `/history/api/v3/decisions/{decision_id}`
                .replace(`{${"decision_id"}}`, encodeURIComponent(String(decisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Decision
         * @param {string} decisionId 
         * @param {GetDecisionHistoryApiV3DecisionsDecisionIdGetViewEnum} [view] 
         * @param {boolean} [parityCheck] 
         * @param {boolean} [iceberg] 
         * @param {string | null} [flowId] 
         * @param {GetDecisionHistoryApiV3DecisionsDecisionIdGetEnvironmentEnum} [environment] 
         * @param {string | null} [$fields] 
         * @param {string | null} [acceptEncoding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisionHistoryApiV3DecisionsDecisionIdGet: async (decisionId: string, view?: GetDecisionHistoryApiV3DecisionsDecisionIdGetViewEnum, parityCheck?: boolean, iceberg?: boolean, flowId?: string | null, environment?: GetDecisionHistoryApiV3DecisionsDecisionIdGetEnvironmentEnum, $fields?: string | null, acceptEncoding?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'decisionId' is not null or undefined
            assertParamExists('getDecisionHistoryApiV3DecisionsDecisionIdGet', 'decisionId', decisionId)
            const localVarPath = `/history/api/v3/decisions/{decision_id}`
                .replace(`{${"decision_id"}}`, encodeURIComponent(String(decisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (view !== undefined) {
                localVarQueryParameter['view'] = view;
            }

            if (parityCheck !== undefined) {
                localVarQueryParameter['parity_check'] = parityCheck;
            }

            if (iceberg !== undefined) {
                localVarQueryParameter['iceberg'] = iceberg;
            }

            if (flowId !== undefined) {
                localVarQueryParameter['flow_id'] = flowId;
            }

            if (environment !== undefined) {
                localVarQueryParameter['environment'] = environment;
            }

            if ($fields !== undefined) {
                localVarQueryParameter['$fields'] = $fields;
            }


    
            if (acceptEncoding != null) {
                localVarHeaderParameter['accept-encoding'] = String(acceptEncoding);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Decisions
         * @param {ListDecisionsHistoryApiV3DecisionsGetViewEnum} [view] 
         * @param {string | null} [startStartTime] 
         * @param {string | null} [endStartTime] 
         * @param {string | null} [startingAfter] 
         * @param {string | null} [startEndTime] 
         * @param {string | null} [endEndTime] 
         * @param {string | null} [pageToken] 
         * @param {number} [pageSize] 
         * @param {ListDecisionsHistoryApiV3DecisionsGetOrderByEnum} [orderBy] 
         * @param {boolean} [iceberg] 
         * @param {boolean} [parityCheck] 
         * @param {string | null} [$fields] 
         * @param {string | null} [flowVersionIds] 
         * @param {string | null} [statuses] 
         * @param {string | null} [statusCodes] 
         * @param {string | null} [jobIds] 
         * @param {string | null} [jobRunIds] 
         * @param {string | null} [parentDecisionIds] 
         * @param {string | null} [parentFlowIds] 
         * @param {string | null} [parentFlowVersionIds] 
         * @param {string | null} [environments] 
         * @param {string | null} [originTypes] 
         * @param {string | null} [groupingIds] Filter by grouping IDs. Comma-separated.
         * @param {string | null} [entityIds] Deprecated. Use grouping_ids instead.
         * @param {string | null} [relatedEntityIds] 
         * @param {string | null} [flowIds] 
         * @param {string | null} [outcomeFilters] 
         * @param {string | null} [caseStatus] 
         * @param {string | null} [caseAssignees] 
         * @param {string | null} [acceptEncoding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDecisionsHistoryApiV3DecisionsGet: async (view?: ListDecisionsHistoryApiV3DecisionsGetViewEnum, startStartTime?: string | null, endStartTime?: string | null, startingAfter?: string | null, startEndTime?: string | null, endEndTime?: string | null, pageToken?: string | null, pageSize?: number, orderBy?: ListDecisionsHistoryApiV3DecisionsGetOrderByEnum, iceberg?: boolean, parityCheck?: boolean, $fields?: string | null, flowVersionIds?: string | null, statuses?: string | null, statusCodes?: string | null, jobIds?: string | null, jobRunIds?: string | null, parentDecisionIds?: string | null, parentFlowIds?: string | null, parentFlowVersionIds?: string | null, environments?: string | null, originTypes?: string | null, groupingIds?: string | null, entityIds?: string | null, relatedEntityIds?: string | null, flowIds?: string | null, outcomeFilters?: string | null, caseStatus?: string | null, caseAssignees?: string | null, acceptEncoding?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/history/api/v3/decisions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (view !== undefined) {
                localVarQueryParameter['view'] = view;
            }

            if (startStartTime !== undefined) {
                localVarQueryParameter['start_start_time'] = (startStartTime as any instanceof Date) ?
                    (startStartTime as any).toISOString() :
                    startStartTime;
            }

            if (endStartTime !== undefined) {
                localVarQueryParameter['end_start_time'] = (endStartTime as any instanceof Date) ?
                    (endStartTime as any).toISOString() :
                    endStartTime;
            }

            if (startingAfter !== undefined) {
                localVarQueryParameter['starting_after'] = startingAfter;
            }

            if (startEndTime !== undefined) {
                localVarQueryParameter['start_end_time'] = (startEndTime as any instanceof Date) ?
                    (startEndTime as any).toISOString() :
                    startEndTime;
            }

            if (endEndTime !== undefined) {
                localVarQueryParameter['end_end_time'] = (endEndTime as any instanceof Date) ?
                    (endEndTime as any).toISOString() :
                    endEndTime;
            }

            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (iceberg !== undefined) {
                localVarQueryParameter['iceberg'] = iceberg;
            }

            if (parityCheck !== undefined) {
                localVarQueryParameter['parity_check'] = parityCheck;
            }

            if ($fields !== undefined) {
                localVarQueryParameter['$fields'] = $fields;
            }

            if (flowVersionIds !== undefined) {
                localVarQueryParameter['flow_version_ids'] = flowVersionIds;
            }

            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (statusCodes !== undefined) {
                localVarQueryParameter['status_codes'] = statusCodes;
            }

            if (jobIds !== undefined) {
                localVarQueryParameter['job_ids'] = jobIds;
            }

            if (jobRunIds !== undefined) {
                localVarQueryParameter['job_run_ids'] = jobRunIds;
            }

            if (parentDecisionIds !== undefined) {
                localVarQueryParameter['parent_decision_ids'] = parentDecisionIds;
            }

            if (parentFlowIds !== undefined) {
                localVarQueryParameter['parent_flow_ids'] = parentFlowIds;
            }

            if (parentFlowVersionIds !== undefined) {
                localVarQueryParameter['parent_flow_version_ids'] = parentFlowVersionIds;
            }

            if (environments !== undefined) {
                localVarQueryParameter['environments'] = environments;
            }

            if (originTypes !== undefined) {
                localVarQueryParameter['origin_types'] = originTypes;
            }

            if (groupingIds !== undefined) {
                localVarQueryParameter['grouping_ids'] = groupingIds;
            }

            if (entityIds !== undefined) {
                localVarQueryParameter['entity_ids'] = entityIds;
            }

            if (relatedEntityIds !== undefined) {
                localVarQueryParameter['related_entity_ids'] = relatedEntityIds;
            }

            if (flowIds !== undefined) {
                localVarQueryParameter['flow_ids'] = flowIds;
            }

            if (outcomeFilters !== undefined) {
                localVarQueryParameter['outcome_filters'] = outcomeFilters;
            }

            if (caseStatus !== undefined) {
                localVarQueryParameter['case_status'] = caseStatus;
            }

            if (caseAssignees !== undefined) {
                localVarQueryParameter['case_assignees'] = caseAssignees;
            }


    
            if (acceptEncoding != null) {
                localVarHeaderParameter['accept-encoding'] = String(acceptEncoding);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DecisionsApi - functional programming interface
 * @export
 */
export const DecisionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DecisionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Expire Decision
         * @param {string} decisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expireDecisionHistoryApiV3DecisionsDecisionIdDelete(decisionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expireDecisionHistoryApiV3DecisionsDecisionIdDelete(decisionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DecisionsApi.expireDecisionHistoryApiV3DecisionsDecisionIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Decision
         * @param {string} decisionId 
         * @param {GetDecisionHistoryApiV3DecisionsDecisionIdGetViewEnum} [view] 
         * @param {boolean} [parityCheck] 
         * @param {boolean} [iceberg] 
         * @param {string | null} [flowId] 
         * @param {GetDecisionHistoryApiV3DecisionsDecisionIdGetEnvironmentEnum} [environment] 
         * @param {string | null} [$fields] 
         * @param {string | null} [acceptEncoding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDecisionHistoryApiV3DecisionsDecisionIdGet(decisionId: string, view?: GetDecisionHistoryApiV3DecisionsDecisionIdGetViewEnum, parityCheck?: boolean, iceberg?: boolean, flowId?: string | null, environment?: GetDecisionHistoryApiV3DecisionsDecisionIdGetEnvironmentEnum, $fields?: string | null, acceptEncoding?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoricalDecisionApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDecisionHistoryApiV3DecisionsDecisionIdGet(decisionId, view, parityCheck, iceberg, flowId, environment, $fields, acceptEncoding, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DecisionsApi.getDecisionHistoryApiV3DecisionsDecisionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Decisions
         * @param {ListDecisionsHistoryApiV3DecisionsGetViewEnum} [view] 
         * @param {string | null} [startStartTime] 
         * @param {string | null} [endStartTime] 
         * @param {string | null} [startingAfter] 
         * @param {string | null} [startEndTime] 
         * @param {string | null} [endEndTime] 
         * @param {string | null} [pageToken] 
         * @param {number} [pageSize] 
         * @param {ListDecisionsHistoryApiV3DecisionsGetOrderByEnum} [orderBy] 
         * @param {boolean} [iceberg] 
         * @param {boolean} [parityCheck] 
         * @param {string | null} [$fields] 
         * @param {string | null} [flowVersionIds] 
         * @param {string | null} [statuses] 
         * @param {string | null} [statusCodes] 
         * @param {string | null} [jobIds] 
         * @param {string | null} [jobRunIds] 
         * @param {string | null} [parentDecisionIds] 
         * @param {string | null} [parentFlowIds] 
         * @param {string | null} [parentFlowVersionIds] 
         * @param {string | null} [environments] 
         * @param {string | null} [originTypes] 
         * @param {string | null} [groupingIds] Filter by grouping IDs. Comma-separated.
         * @param {string | null} [entityIds] Deprecated. Use grouping_ids instead.
         * @param {string | null} [relatedEntityIds] 
         * @param {string | null} [flowIds] 
         * @param {string | null} [outcomeFilters] 
         * @param {string | null} [caseStatus] 
         * @param {string | null} [caseAssignees] 
         * @param {string | null} [acceptEncoding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDecisionsHistoryApiV3DecisionsGet(view?: ListDecisionsHistoryApiV3DecisionsGetViewEnum, startStartTime?: string | null, endStartTime?: string | null, startingAfter?: string | null, startEndTime?: string | null, endEndTime?: string | null, pageToken?: string | null, pageSize?: number, orderBy?: ListDecisionsHistoryApiV3DecisionsGetOrderByEnum, iceberg?: boolean, parityCheck?: boolean, $fields?: string | null, flowVersionIds?: string | null, statuses?: string | null, statusCodes?: string | null, jobIds?: string | null, jobRunIds?: string | null, parentDecisionIds?: string | null, parentFlowIds?: string | null, parentFlowVersionIds?: string | null, environments?: string | null, originTypes?: string | null, groupingIds?: string | null, entityIds?: string | null, relatedEntityIds?: string | null, flowIds?: string | null, outcomeFilters?: string | null, caseStatus?: string | null, caseAssignees?: string | null, acceptEncoding?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DecisionList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDecisionsHistoryApiV3DecisionsGet(view, startStartTime, endStartTime, startingAfter, startEndTime, endEndTime, pageToken, pageSize, orderBy, iceberg, parityCheck, $fields, flowVersionIds, statuses, statusCodes, jobIds, jobRunIds, parentDecisionIds, parentFlowIds, parentFlowVersionIds, environments, originTypes, groupingIds, entityIds, relatedEntityIds, flowIds, outcomeFilters, caseStatus, caseAssignees, acceptEncoding, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DecisionsApi.listDecisionsHistoryApiV3DecisionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DecisionsApi - factory interface
 * @export
 */
export const DecisionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DecisionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Expire Decision
         * @param {DecisionsApiExpireDecisionHistoryApiV3DecisionsDecisionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireDecisionHistoryApiV3DecisionsDecisionIdDelete(requestParameters: DecisionsApiExpireDecisionHistoryApiV3DecisionsDecisionIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.expireDecisionHistoryApiV3DecisionsDecisionIdDelete(requestParameters.decisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Decision
         * @param {DecisionsApiGetDecisionHistoryApiV3DecisionsDecisionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDecisionHistoryApiV3DecisionsDecisionIdGet(requestParameters: DecisionsApiGetDecisionHistoryApiV3DecisionsDecisionIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<HistoricalDecisionApiResponse> {
            return localVarFp.getDecisionHistoryApiV3DecisionsDecisionIdGet(requestParameters.decisionId, requestParameters.view, requestParameters.parityCheck, requestParameters.iceberg, requestParameters.flowId, requestParameters.environment, requestParameters.$fields, requestParameters.acceptEncoding, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Decisions
         * @param {DecisionsApiListDecisionsHistoryApiV3DecisionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDecisionsHistoryApiV3DecisionsGet(requestParameters: DecisionsApiListDecisionsHistoryApiV3DecisionsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<DecisionList> {
            return localVarFp.listDecisionsHistoryApiV3DecisionsGet(requestParameters.view, requestParameters.startStartTime, requestParameters.endStartTime, requestParameters.startingAfter, requestParameters.startEndTime, requestParameters.endEndTime, requestParameters.pageToken, requestParameters.pageSize, requestParameters.orderBy, requestParameters.iceberg, requestParameters.parityCheck, requestParameters.$fields, requestParameters.flowVersionIds, requestParameters.statuses, requestParameters.statusCodes, requestParameters.jobIds, requestParameters.jobRunIds, requestParameters.parentDecisionIds, requestParameters.parentFlowIds, requestParameters.parentFlowVersionIds, requestParameters.environments, requestParameters.originTypes, requestParameters.groupingIds, requestParameters.entityIds, requestParameters.relatedEntityIds, requestParameters.flowIds, requestParameters.outcomeFilters, requestParameters.caseStatus, requestParameters.caseAssignees, requestParameters.acceptEncoding, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for expireDecisionHistoryApiV3DecisionsDecisionIdDelete operation in DecisionsApi.
 * @export
 * @interface DecisionsApiExpireDecisionHistoryApiV3DecisionsDecisionIdDeleteRequest
 */
export interface DecisionsApiExpireDecisionHistoryApiV3DecisionsDecisionIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof DecisionsApiExpireDecisionHistoryApiV3DecisionsDecisionIdDelete
     */
    readonly decisionId: string
}

/**
 * Request parameters for getDecisionHistoryApiV3DecisionsDecisionIdGet operation in DecisionsApi.
 * @export
 * @interface DecisionsApiGetDecisionHistoryApiV3DecisionsDecisionIdGetRequest
 */
export interface DecisionsApiGetDecisionHistoryApiV3DecisionsDecisionIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DecisionsApiGetDecisionHistoryApiV3DecisionsDecisionIdGet
     */
    readonly decisionId: string

    /**
     * 
     * @type {'basic' | 'integration_durations' | 'internal'}
     * @memberof DecisionsApiGetDecisionHistoryApiV3DecisionsDecisionIdGet
     */
    readonly view?: GetDecisionHistoryApiV3DecisionsDecisionIdGetViewEnum

    /**
     * 
     * @type {boolean}
     * @memberof DecisionsApiGetDecisionHistoryApiV3DecisionsDecisionIdGet
     */
    readonly parityCheck?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DecisionsApiGetDecisionHistoryApiV3DecisionsDecisionIdGet
     */
    readonly iceberg?: boolean

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiGetDecisionHistoryApiV3DecisionsDecisionIdGet
     */
    readonly flowId?: string | null

    /**
     * 
     * @type {'live' | 'sandbox'}
     * @memberof DecisionsApiGetDecisionHistoryApiV3DecisionsDecisionIdGet
     */
    readonly environment?: GetDecisionHistoryApiV3DecisionsDecisionIdGetEnvironmentEnum

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiGetDecisionHistoryApiV3DecisionsDecisionIdGet
     */
    readonly $fields?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiGetDecisionHistoryApiV3DecisionsDecisionIdGet
     */
    readonly acceptEncoding?: string | null
}

/**
 * Request parameters for listDecisionsHistoryApiV3DecisionsGet operation in DecisionsApi.
 * @export
 * @interface DecisionsApiListDecisionsHistoryApiV3DecisionsGetRequest
 */
export interface DecisionsApiListDecisionsHistoryApiV3DecisionsGetRequest {
    /**
     * 
     * @type {'basic' | 'internal'}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly view?: ListDecisionsHistoryApiV3DecisionsGetViewEnum

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly startStartTime?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly endStartTime?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly startingAfter?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly startEndTime?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly endEndTime?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly pageToken?: string | null

    /**
     * 
     * @type {number}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {'start_time desc' | 'end_time asc'}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly orderBy?: ListDecisionsHistoryApiV3DecisionsGetOrderByEnum

    /**
     * 
     * @type {boolean}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly iceberg?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly parityCheck?: boolean

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly $fields?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly flowVersionIds?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly statuses?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly statusCodes?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly jobIds?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly jobRunIds?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly parentDecisionIds?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly parentFlowIds?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly parentFlowVersionIds?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly environments?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly originTypes?: string | null

    /**
     * Filter by grouping IDs. Comma-separated.
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly groupingIds?: string | null

    /**
     * Deprecated. Use grouping_ids instead.
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly entityIds?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly relatedEntityIds?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly flowIds?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly outcomeFilters?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly caseStatus?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly caseAssignees?: string | null

    /**
     * 
     * @type {string}
     * @memberof DecisionsApiListDecisionsHistoryApiV3DecisionsGet
     */
    readonly acceptEncoding?: string | null
}

/**
 * DecisionsApi - object-oriented interface
 * @export
 * @class DecisionsApi
 * @extends {BaseAPI}
 */
export class DecisionsApi extends BaseAPI {
    /**
     * 
     * @summary Expire Decision
     * @param {DecisionsApiExpireDecisionHistoryApiV3DecisionsDecisionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DecisionsApi
     */
    public expireDecisionHistoryApiV3DecisionsDecisionIdDelete(requestParameters: DecisionsApiExpireDecisionHistoryApiV3DecisionsDecisionIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DecisionsApiFp(this.configuration).expireDecisionHistoryApiV3DecisionsDecisionIdDelete(requestParameters.decisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Decision
     * @param {DecisionsApiGetDecisionHistoryApiV3DecisionsDecisionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DecisionsApi
     */
    public getDecisionHistoryApiV3DecisionsDecisionIdGet(requestParameters: DecisionsApiGetDecisionHistoryApiV3DecisionsDecisionIdGetRequest, options?: RawAxiosRequestConfig) {
        return DecisionsApiFp(this.configuration).getDecisionHistoryApiV3DecisionsDecisionIdGet(requestParameters.decisionId, requestParameters.view, requestParameters.parityCheck, requestParameters.iceberg, requestParameters.flowId, requestParameters.environment, requestParameters.$fields, requestParameters.acceptEncoding, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Decisions
     * @param {DecisionsApiListDecisionsHistoryApiV3DecisionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DecisionsApi
     */
    public listDecisionsHistoryApiV3DecisionsGet(requestParameters: DecisionsApiListDecisionsHistoryApiV3DecisionsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DecisionsApiFp(this.configuration).listDecisionsHistoryApiV3DecisionsGet(requestParameters.view, requestParameters.startStartTime, requestParameters.endStartTime, requestParameters.startingAfter, requestParameters.startEndTime, requestParameters.endEndTime, requestParameters.pageToken, requestParameters.pageSize, requestParameters.orderBy, requestParameters.iceberg, requestParameters.parityCheck, requestParameters.$fields, requestParameters.flowVersionIds, requestParameters.statuses, requestParameters.statusCodes, requestParameters.jobIds, requestParameters.jobRunIds, requestParameters.parentDecisionIds, requestParameters.parentFlowIds, requestParameters.parentFlowVersionIds, requestParameters.environments, requestParameters.originTypes, requestParameters.groupingIds, requestParameters.entityIds, requestParameters.relatedEntityIds, requestParameters.flowIds, requestParameters.outcomeFilters, requestParameters.caseStatus, requestParameters.caseAssignees, requestParameters.acceptEncoding, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetDecisionHistoryApiV3DecisionsDecisionIdGetViewEnum = {
    BASIC: 'basic',
    INTEGRATION_DURATIONS: 'integration_durations',
    INTERNAL: 'internal'
} as const;
export type GetDecisionHistoryApiV3DecisionsDecisionIdGetViewEnum = typeof GetDecisionHistoryApiV3DecisionsDecisionIdGetViewEnum[keyof typeof GetDecisionHistoryApiV3DecisionsDecisionIdGetViewEnum];
/**
 * @export
 */
export const GetDecisionHistoryApiV3DecisionsDecisionIdGetEnvironmentEnum = {
    LIVE: 'live',
    SANDBOX: 'sandbox'
} as const;
export type GetDecisionHistoryApiV3DecisionsDecisionIdGetEnvironmentEnum = typeof GetDecisionHistoryApiV3DecisionsDecisionIdGetEnvironmentEnum[keyof typeof GetDecisionHistoryApiV3DecisionsDecisionIdGetEnvironmentEnum];
/**
 * @export
 */
export const ListDecisionsHistoryApiV3DecisionsGetViewEnum = {
    BASIC: 'basic',
    INTERNAL: 'internal'
} as const;
export type ListDecisionsHistoryApiV3DecisionsGetViewEnum = typeof ListDecisionsHistoryApiV3DecisionsGetViewEnum[keyof typeof ListDecisionsHistoryApiV3DecisionsGetViewEnum];
/**
 * @export
 */
export const ListDecisionsHistoryApiV3DecisionsGetOrderByEnum = {
    START_TIME_DESC: 'start_time desc',
    END_TIME_ASC: 'end_time asc'
} as const;
export type ListDecisionsHistoryApiV3DecisionsGetOrderByEnum = typeof ListDecisionsHistoryApiV3DecisionsGetOrderByEnum[keyof typeof ListDecisionsHistoryApiV3DecisionsGetOrderByEnum];


/**
 * ExportsApi - axios parameter creator
 * @export
 */
export const ExportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export Decisions
         * @param {HistoricalDecisionExportCreate} historicalDecisionExportCreate 
         * @param {boolean} [iceberg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportDecisionsHistoryApiV3DecisionsExportsPost: async (historicalDecisionExportCreate: HistoricalDecisionExportCreate, iceberg?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'historicalDecisionExportCreate' is not null or undefined
            assertParamExists('exportDecisionsHistoryApiV3DecisionsExportsPost', 'historicalDecisionExportCreate', historicalDecisionExportCreate)
            const localVarPath = `/history/api/v3/decisions/exports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (iceberg !== undefined) {
                localVarQueryParameter['iceberg'] = iceberg;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(historicalDecisionExportCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Export
         * @param {string} exportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportHistoryApiV3DecisionsExportsExportIdGet: async (exportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportId' is not null or undefined
            assertParamExists('getExportHistoryApiV3DecisionsExportsExportIdGet', 'exportId', exportId)
            const localVarPath = `/history/api/v3/decisions/exports/{export_id}`
                .replace(`{${"export_id"}}`, encodeURIComponent(String(exportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Exports
         * @param {string | null} [startCreatedAt] 
         * @param {string | null} [endCreatedAt] 
         * @param {string | null} [startingAfter] 
         * @param {string | null} [pageToken] 
         * @param {number} [pageSize] 
         * @param {string | null} [createdByIds] 
         * @param {string | null} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExportsHistoryApiV3DecisionsExportsGet: async (startCreatedAt?: string | null, endCreatedAt?: string | null, startingAfter?: string | null, pageToken?: string | null, pageSize?: number, createdByIds?: string | null, statuses?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/history/api/v3/decisions/exports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (startCreatedAt !== undefined) {
                localVarQueryParameter['start_created_at'] = (startCreatedAt as any instanceof Date) ?
                    (startCreatedAt as any).toISOString() :
                    startCreatedAt;
            }

            if (endCreatedAt !== undefined) {
                localVarQueryParameter['end_created_at'] = (endCreatedAt as any instanceof Date) ?
                    (endCreatedAt as any).toISOString() :
                    endCreatedAt;
            }

            if (startingAfter !== undefined) {
                localVarQueryParameter['starting_after'] = startingAfter;
            }

            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (createdByIds !== undefined) {
                localVarQueryParameter['created_by_ids'] = createdByIds;
            }

            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportsApi - functional programming interface
 * @export
 */
export const ExportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export Decisions
         * @param {HistoricalDecisionExportCreate} historicalDecisionExportCreate 
         * @param {boolean} [iceberg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportDecisionsHistoryApiV3DecisionsExportsPost(historicalDecisionExportCreate: HistoricalDecisionExportCreate, iceberg?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoricalDecisionExportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportDecisionsHistoryApiV3DecisionsExportsPost(historicalDecisionExportCreate, iceberg, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportsApi.exportDecisionsHistoryApiV3DecisionsExportsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Export
         * @param {string} exportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExportHistoryApiV3DecisionsExportsExportIdGet(exportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoricalDecisionExportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExportHistoryApiV3DecisionsExportsExportIdGet(exportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportsApi.getExportHistoryApiV3DecisionsExportsExportIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Exports
         * @param {string | null} [startCreatedAt] 
         * @param {string | null} [endCreatedAt] 
         * @param {string | null} [startingAfter] 
         * @param {string | null} [pageToken] 
         * @param {number} [pageSize] 
         * @param {string | null} [createdByIds] 
         * @param {string | null} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listExportsHistoryApiV3DecisionsExportsGet(startCreatedAt?: string | null, endCreatedAt?: string | null, startingAfter?: string | null, pageToken?: string | null, pageSize?: number, createdByIds?: string | null, statuses?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListExportResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listExportsHistoryApiV3DecisionsExportsGet(startCreatedAt, endCreatedAt, startingAfter, pageToken, pageSize, createdByIds, statuses, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExportsApi.listExportsHistoryApiV3DecisionsExportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExportsApi - factory interface
 * @export
 */
export const ExportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Export Decisions
         * @param {ExportsApiExportDecisionsHistoryApiV3DecisionsExportsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportDecisionsHistoryApiV3DecisionsExportsPost(requestParameters: ExportsApiExportDecisionsHistoryApiV3DecisionsExportsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<HistoricalDecisionExportResponse> {
            return localVarFp.exportDecisionsHistoryApiV3DecisionsExportsPost(requestParameters.historicalDecisionExportCreate, requestParameters.iceberg, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Export
         * @param {ExportsApiGetExportHistoryApiV3DecisionsExportsExportIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportHistoryApiV3DecisionsExportsExportIdGet(requestParameters: ExportsApiGetExportHistoryApiV3DecisionsExportsExportIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<HistoricalDecisionExportResponse> {
            return localVarFp.getExportHistoryApiV3DecisionsExportsExportIdGet(requestParameters.exportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Exports
         * @param {ExportsApiListExportsHistoryApiV3DecisionsExportsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExportsHistoryApiV3DecisionsExportsGet(requestParameters: ExportsApiListExportsHistoryApiV3DecisionsExportsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListExportResponseModel> {
            return localVarFp.listExportsHistoryApiV3DecisionsExportsGet(requestParameters.startCreatedAt, requestParameters.endCreatedAt, requestParameters.startingAfter, requestParameters.pageToken, requestParameters.pageSize, requestParameters.createdByIds, requestParameters.statuses, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for exportDecisionsHistoryApiV3DecisionsExportsPost operation in ExportsApi.
 * @export
 * @interface ExportsApiExportDecisionsHistoryApiV3DecisionsExportsPostRequest
 */
export interface ExportsApiExportDecisionsHistoryApiV3DecisionsExportsPostRequest {
    /**
     * 
     * @type {HistoricalDecisionExportCreate}
     * @memberof ExportsApiExportDecisionsHistoryApiV3DecisionsExportsPost
     */
    readonly historicalDecisionExportCreate: HistoricalDecisionExportCreate

    /**
     * 
     * @type {boolean}
     * @memberof ExportsApiExportDecisionsHistoryApiV3DecisionsExportsPost
     */
    readonly iceberg?: boolean
}

/**
 * Request parameters for getExportHistoryApiV3DecisionsExportsExportIdGet operation in ExportsApi.
 * @export
 * @interface ExportsApiGetExportHistoryApiV3DecisionsExportsExportIdGetRequest
 */
export interface ExportsApiGetExportHistoryApiV3DecisionsExportsExportIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ExportsApiGetExportHistoryApiV3DecisionsExportsExportIdGet
     */
    readonly exportId: string
}

/**
 * Request parameters for listExportsHistoryApiV3DecisionsExportsGet operation in ExportsApi.
 * @export
 * @interface ExportsApiListExportsHistoryApiV3DecisionsExportsGetRequest
 */
export interface ExportsApiListExportsHistoryApiV3DecisionsExportsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ExportsApiListExportsHistoryApiV3DecisionsExportsGet
     */
    readonly startCreatedAt?: string | null

    /**
     * 
     * @type {string}
     * @memberof ExportsApiListExportsHistoryApiV3DecisionsExportsGet
     */
    readonly endCreatedAt?: string | null

    /**
     * 
     * @type {string}
     * @memberof ExportsApiListExportsHistoryApiV3DecisionsExportsGet
     */
    readonly startingAfter?: string | null

    /**
     * 
     * @type {string}
     * @memberof ExportsApiListExportsHistoryApiV3DecisionsExportsGet
     */
    readonly pageToken?: string | null

    /**
     * 
     * @type {number}
     * @memberof ExportsApiListExportsHistoryApiV3DecisionsExportsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof ExportsApiListExportsHistoryApiV3DecisionsExportsGet
     */
    readonly createdByIds?: string | null

    /**
     * 
     * @type {string}
     * @memberof ExportsApiListExportsHistoryApiV3DecisionsExportsGet
     */
    readonly statuses?: string | null
}

/**
 * ExportsApi - object-oriented interface
 * @export
 * @class ExportsApi
 * @extends {BaseAPI}
 */
export class ExportsApi extends BaseAPI {
    /**
     * 
     * @summary Export Decisions
     * @param {ExportsApiExportDecisionsHistoryApiV3DecisionsExportsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportsApi
     */
    public exportDecisionsHistoryApiV3DecisionsExportsPost(requestParameters: ExportsApiExportDecisionsHistoryApiV3DecisionsExportsPostRequest, options?: RawAxiosRequestConfig) {
        return ExportsApiFp(this.configuration).exportDecisionsHistoryApiV3DecisionsExportsPost(requestParameters.historicalDecisionExportCreate, requestParameters.iceberg, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Export
     * @param {ExportsApiGetExportHistoryApiV3DecisionsExportsExportIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportsApi
     */
    public getExportHistoryApiV3DecisionsExportsExportIdGet(requestParameters: ExportsApiGetExportHistoryApiV3DecisionsExportsExportIdGetRequest, options?: RawAxiosRequestConfig) {
        return ExportsApiFp(this.configuration).getExportHistoryApiV3DecisionsExportsExportIdGet(requestParameters.exportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Exports
     * @param {ExportsApiListExportsHistoryApiV3DecisionsExportsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportsApi
     */
    public listExportsHistoryApiV3DecisionsExportsGet(requestParameters: ExportsApiListExportsHistoryApiV3DecisionsExportsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return ExportsApiFp(this.configuration).listExportsHistoryApiV3DecisionsExportsGet(requestParameters.startCreatedAt, requestParameters.endCreatedAt, requestParameters.startingAfter, requestParameters.pageToken, requestParameters.pageSize, requestParameters.createdByIds, requestParameters.statuses, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NodeExecutionsApi - axios parameter creator
 * @export
 */
export const NodeExecutionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a run\'s node-executions (shards, counts, manifest) — leaving an empty destination for the UNLOAD.  Relevant in case of retries so we clean up the dirty state.
         * @summary Clear Node Executions Route
         * @param {string} jobRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDelete: async (jobRunId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobRunId' is not null or undefined
            assertParamExists('clearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDelete', 'jobRunId', jobRunId)
            const localVarPath = `/history/api/v3/job_runs/{job_run_id}/node_executions/manifest`
                .replace(`{${"job_run_id"}}`, encodeURIComponent(String(jobRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pre-signed URLs for a completed run\'s eagerly-generated result shards, grouped by node_id.
         * @summary Get Node Execution File Urls
         * @param {string} jobRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGet: async (jobRunId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobRunId' is not null or undefined
            assertParamExists('getNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGet', 'jobRunId', jobRunId)
            const localVarPath = `/history/api/v3/job_runs/{job_run_id}/node_executions`
                .replace(`{${"job_run_id"}}`, encodeURIComponent(String(jobRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Poll the Athena state of a node-executions UNLOAD started by the trigger.
         * @summary Get Node Executions Generation Status Route
         * @param {string} jobRunId 
         * @param {string} queryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGet: async (jobRunId: string, queryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobRunId' is not null or undefined
            assertParamExists('getNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGet', 'jobRunId', jobRunId)
            // verify required parameter 'queryId' is not null or undefined
            assertParamExists('getNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGet', 'queryId', queryId)
            const localVarPath = `/history/api/v3/job_runs/{job_run_id}/node_executions/status`
                .replace(`{${"job_run_id"}}`, encodeURIComponent(String(jobRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (queryId !== undefined) {
                localVarQueryParameter['query_id'] = queryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Whether a run\'s node-executions are generated and ready (the manifest exists).
         * @summary Get Node Executions Manifest
         * @param {string} jobRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGet: async (jobRunId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobRunId' is not null or undefined
            assertParamExists('getNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGet', 'jobRunId', jobRunId)
            const localVarPath = `/history/api/v3/job_runs/{job_run_id}/node_executions/manifest`
                .replace(`{${"job_run_id"}}`, encodeURIComponent(String(jobRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Node Executions
         * @param {string} nodeId 
         * @param {string} jobRunId 
         * @param {string} flowId 
         * @param {DecisionEnvironment} environment 
         * @param {string} fromStartTime 
         * @param {string} untilStartTime 
         * @param {string | null} [afterDecisionId] 
         * @param {string | null} [beforeDecisionId] 
         * @param {number} [pageSize] 
         * @param {SortDirection} [sortDirection] 
         * @param {string | null} [statuses] 
         * @param {string | null} [acceptEncoding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet: async (nodeId: string, jobRunId: string, flowId: string, environment: DecisionEnvironment, fromStartTime: string, untilStartTime: string, afterDecisionId?: string | null, beforeDecisionId?: string | null, pageSize?: number, sortDirection?: SortDirection, statuses?: string | null, acceptEncoding?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet', 'nodeId', nodeId)
            // verify required parameter 'jobRunId' is not null or undefined
            assertParamExists('listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet', 'jobRunId', jobRunId)
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet', 'flowId', flowId)
            // verify required parameter 'environment' is not null or undefined
            assertParamExists('listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet', 'environment', environment)
            // verify required parameter 'fromStartTime' is not null or undefined
            assertParamExists('listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet', 'fromStartTime', fromStartTime)
            // verify required parameter 'untilStartTime' is not null or undefined
            assertParamExists('listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet', 'untilStartTime', untilStartTime)
            const localVarPath = `/history/api/v3/node_executions/{node_id}`
                .replace(`{${"node_id"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (jobRunId !== undefined) {
                localVarQueryParameter['job_run_id'] = jobRunId;
            }

            if (flowId !== undefined) {
                localVarQueryParameter['flow_id'] = flowId;
            }

            if (environment !== undefined) {
                localVarQueryParameter['environment'] = environment;
            }

            if (fromStartTime !== undefined) {
                localVarQueryParameter['from_start_time'] = (fromStartTime as any instanceof Date) ?
                    (fromStartTime as any).toISOString() :
                    fromStartTime;
            }

            if (untilStartTime !== undefined) {
                localVarQueryParameter['until_start_time'] = (untilStartTime as any instanceof Date) ?
                    (untilStartTime as any).toISOString() :
                    untilStartTime;
            }

            if (afterDecisionId !== undefined) {
                localVarQueryParameter['after_decision_id'] = afterDecisionId;
            }

            if (beforeDecisionId !== undefined) {
                localVarQueryParameter['before_decision_id'] = beforeDecisionId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }


    
            if (acceptEncoding != null) {
                localVarHeaderParameter['accept-encoding'] = String(acceptEncoding);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Write the manifest marker — flips a run\'s node-executions & node couts to \"ready\".
         * @summary Mark Node Executions Available
         * @param {string} jobRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPost: async (jobRunId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobRunId' is not null or undefined
            assertParamExists('markNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPost', 'jobRunId', jobRunId)
            const localVarPath = `/history/api/v3/job_runs/{job_run_id}/node_executions/manifest`
                .replace(`{${"job_run_id"}}`, encodeURIComponent(String(jobRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start the eager node-executions UNLOAD for a completed long running test run. It doesn\'t block the caller and the caller is responsible the poll for the result.
         * @summary Trigger Job Node Execution Generation
         * @param {string} jobRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPost: async (jobRunId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobRunId' is not null or undefined
            assertParamExists('triggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPost', 'jobRunId', jobRunId)
            const localVarPath = `/history/api/v3/job_runs/{job_run_id}/node_executions`
                .replace(`{${"job_run_id"}}`, encodeURIComponent(String(jobRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NodeExecutionsApi - functional programming interface
 * @export
 */
export const NodeExecutionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NodeExecutionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a run\'s node-executions (shards, counts, manifest) — leaving an empty destination for the UNLOAD.  Relevant in case of retries so we clean up the dirty state.
         * @summary Clear Node Executions Route
         * @param {string} jobRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDelete(jobRunId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDelete(jobRunId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeExecutionsApi.clearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pre-signed URLs for a completed run\'s eagerly-generated result shards, grouped by node_id.
         * @summary Get Node Execution File Urls
         * @param {string} jobRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGet(jobRunId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeExecutionsFileUrls>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGet(jobRunId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeExecutionsApi.getNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Poll the Athena state of a node-executions UNLOAD started by the trigger.
         * @summary Get Node Executions Generation Status Route
         * @param {string} jobRunId 
         * @param {string} queryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGet(jobRunId: string, queryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeExecutionsGenerationStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGet(jobRunId, queryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeExecutionsApi.getNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Whether a run\'s node-executions are generated and ready (the manifest exists).
         * @summary Get Node Executions Manifest
         * @param {string} jobRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGet(jobRunId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeExecutionsManifest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGet(jobRunId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeExecutionsApi.getNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Node Executions
         * @param {string} nodeId 
         * @param {string} jobRunId 
         * @param {string} flowId 
         * @param {DecisionEnvironment} environment 
         * @param {string} fromStartTime 
         * @param {string} untilStartTime 
         * @param {string | null} [afterDecisionId] 
         * @param {string | null} [beforeDecisionId] 
         * @param {number} [pageSize] 
         * @param {SortDirection} [sortDirection] 
         * @param {string | null} [statuses] 
         * @param {string | null} [acceptEncoding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet(nodeId: string, jobRunId: string, flowId: string, environment: DecisionEnvironment, fromStartTime: string, untilStartTime: string, afterDecisionId?: string | null, beforeDecisionId?: string | null, pageSize?: number, sortDirection?: SortDirection, statuses?: string | null, acceptEncoding?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeExecutionsPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet(nodeId, jobRunId, flowId, environment, fromStartTime, untilStartTime, afterDecisionId, beforeDecisionId, pageSize, sortDirection, statuses, acceptEncoding, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeExecutionsApi.listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Write the manifest marker — flips a run\'s node-executions & node couts to \"ready\".
         * @summary Mark Node Executions Available
         * @param {string} jobRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPost(jobRunId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeExecutionsManifest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPost(jobRunId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeExecutionsApi.markNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start the eager node-executions UNLOAD for a completed long running test run. It doesn\'t block the caller and the caller is responsible the poll for the result.
         * @summary Trigger Job Node Execution Generation
         * @param {string} jobRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPost(jobRunId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TriggerNodeExecutionsGenerationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPost(jobRunId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeExecutionsApi.triggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NodeExecutionsApi - factory interface
 * @export
 */
export const NodeExecutionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NodeExecutionsApiFp(configuration)
    return {
        /**
         * Delete a run\'s node-executions (shards, counts, manifest) — leaving an empty destination for the UNLOAD.  Relevant in case of retries so we clean up the dirty state.
         * @summary Clear Node Executions Route
         * @param {NodeExecutionsApiClearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDelete(requestParameters: NodeExecutionsApiClearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDelete(requestParameters.jobRunId, options).then((request) => request(axios, basePath));
        },
        /**
         * Pre-signed URLs for a completed run\'s eagerly-generated result shards, grouped by node_id.
         * @summary Get Node Execution File Urls
         * @param {NodeExecutionsApiGetNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGet(requestParameters: NodeExecutionsApiGetNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeExecutionsFileUrls> {
            return localVarFp.getNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGet(requestParameters.jobRunId, options).then((request) => request(axios, basePath));
        },
        /**
         * Poll the Athena state of a node-executions UNLOAD started by the trigger.
         * @summary Get Node Executions Generation Status Route
         * @param {NodeExecutionsApiGetNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGet(requestParameters: NodeExecutionsApiGetNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeExecutionsGenerationStatus> {
            return localVarFp.getNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGet(requestParameters.jobRunId, requestParameters.queryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Whether a run\'s node-executions are generated and ready (the manifest exists).
         * @summary Get Node Executions Manifest
         * @param {NodeExecutionsApiGetNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGet(requestParameters: NodeExecutionsApiGetNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeExecutionsManifest> {
            return localVarFp.getNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGet(requestParameters.jobRunId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Node Executions
         * @param {NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet(requestParameters: NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeExecutionsPage> {
            return localVarFp.listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet(requestParameters.nodeId, requestParameters.jobRunId, requestParameters.flowId, requestParameters.environment, requestParameters.fromStartTime, requestParameters.untilStartTime, requestParameters.afterDecisionId, requestParameters.beforeDecisionId, requestParameters.pageSize, requestParameters.sortDirection, requestParameters.statuses, requestParameters.acceptEncoding, options).then((request) => request(axios, basePath));
        },
        /**
         * Write the manifest marker — flips a run\'s node-executions & node couts to \"ready\".
         * @summary Mark Node Executions Available
         * @param {NodeExecutionsApiMarkNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPost(requestParameters: NodeExecutionsApiMarkNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeExecutionsManifest> {
            return localVarFp.markNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPost(requestParameters.jobRunId, options).then((request) => request(axios, basePath));
        },
        /**
         * Start the eager node-executions UNLOAD for a completed long running test run. It doesn\'t block the caller and the caller is responsible the poll for the result.
         * @summary Trigger Job Node Execution Generation
         * @param {NodeExecutionsApiTriggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPost(requestParameters: NodeExecutionsApiTriggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<TriggerNodeExecutionsGenerationResponse> {
            return localVarFp.triggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPost(requestParameters.jobRunId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for clearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDelete operation in NodeExecutionsApi.
 * @export
 * @interface NodeExecutionsApiClearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDeleteRequest
 */
export interface NodeExecutionsApiClearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiClearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDelete
     */
    readonly jobRunId: string
}

/**
 * Request parameters for getNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGet operation in NodeExecutionsApi.
 * @export
 * @interface NodeExecutionsApiGetNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGetRequest
 */
export interface NodeExecutionsApiGetNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiGetNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGet
     */
    readonly jobRunId: string
}

/**
 * Request parameters for getNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGet operation in NodeExecutionsApi.
 * @export
 * @interface NodeExecutionsApiGetNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGetRequest
 */
export interface NodeExecutionsApiGetNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGetRequest {
    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiGetNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGet
     */
    readonly jobRunId: string

    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiGetNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGet
     */
    readonly queryId: string
}

/**
 * Request parameters for getNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGet operation in NodeExecutionsApi.
 * @export
 * @interface NodeExecutionsApiGetNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGetRequest
 */
export interface NodeExecutionsApiGetNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGetRequest {
    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiGetNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGet
     */
    readonly jobRunId: string
}

/**
 * Request parameters for listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet operation in NodeExecutionsApi.
 * @export
 * @interface NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGetRequest
 */
export interface NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet
     */
    readonly nodeId: string

    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet
     */
    readonly jobRunId: string

    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet
     */
    readonly flowId: string

    /**
     * 
     * @type {DecisionEnvironment}
     * @memberof NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet
     */
    readonly environment: DecisionEnvironment

    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet
     */
    readonly fromStartTime: string

    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet
     */
    readonly untilStartTime: string

    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet
     */
    readonly afterDecisionId?: string | null

    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet
     */
    readonly beforeDecisionId?: string | null

    /**
     * 
     * @type {number}
     * @memberof NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {SortDirection}
     * @memberof NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet
     */
    readonly sortDirection?: SortDirection

    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet
     */
    readonly statuses?: string | null

    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet
     */
    readonly acceptEncoding?: string | null
}

/**
 * Request parameters for markNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPost operation in NodeExecutionsApi.
 * @export
 * @interface NodeExecutionsApiMarkNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPostRequest
 */
export interface NodeExecutionsApiMarkNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPostRequest {
    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiMarkNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPost
     */
    readonly jobRunId: string
}

/**
 * Request parameters for triggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPost operation in NodeExecutionsApi.
 * @export
 * @interface NodeExecutionsApiTriggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPostRequest
 */
export interface NodeExecutionsApiTriggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof NodeExecutionsApiTriggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPost
     */
    readonly jobRunId: string
}

/**
 * NodeExecutionsApi - object-oriented interface
 * @export
 * @class NodeExecutionsApi
 * @extends {BaseAPI}
 */
export class NodeExecutionsApi extends BaseAPI {
    /**
     * Delete a run\'s node-executions (shards, counts, manifest) — leaving an empty destination for the UNLOAD.  Relevant in case of retries so we clean up the dirty state.
     * @summary Clear Node Executions Route
     * @param {NodeExecutionsApiClearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeExecutionsApi
     */
    public clearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDelete(requestParameters: NodeExecutionsApiClearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDeleteRequest, options?: RawAxiosRequestConfig) {
        return NodeExecutionsApiFp(this.configuration).clearNodeExecutionsRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestDelete(requestParameters.jobRunId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pre-signed URLs for a completed run\'s eagerly-generated result shards, grouped by node_id.
     * @summary Get Node Execution File Urls
     * @param {NodeExecutionsApiGetNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeExecutionsApi
     */
    public getNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGet(requestParameters: NodeExecutionsApiGetNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGetRequest, options?: RawAxiosRequestConfig) {
        return NodeExecutionsApiFp(this.configuration).getNodeExecutionFileUrlsHistoryApiV3JobRunsJobRunIdNodeExecutionsGet(requestParameters.jobRunId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Poll the Athena state of a node-executions UNLOAD started by the trigger.
     * @summary Get Node Executions Generation Status Route
     * @param {NodeExecutionsApiGetNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeExecutionsApi
     */
    public getNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGet(requestParameters: NodeExecutionsApiGetNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGetRequest, options?: RawAxiosRequestConfig) {
        return NodeExecutionsApiFp(this.configuration).getNodeExecutionsGenerationStatusRouteHistoryApiV3JobRunsJobRunIdNodeExecutionsStatusGet(requestParameters.jobRunId, requestParameters.queryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Whether a run\'s node-executions are generated and ready (the manifest exists).
     * @summary Get Node Executions Manifest
     * @param {NodeExecutionsApiGetNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeExecutionsApi
     */
    public getNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGet(requestParameters: NodeExecutionsApiGetNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGetRequest, options?: RawAxiosRequestConfig) {
        return NodeExecutionsApiFp(this.configuration).getNodeExecutionsManifestHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestGet(requestParameters.jobRunId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Node Executions
     * @param {NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeExecutionsApi
     */
    public listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet(requestParameters: NodeExecutionsApiListNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGetRequest, options?: RawAxiosRequestConfig) {
        return NodeExecutionsApiFp(this.configuration).listNodeExecutionsHistoryApiV3NodeExecutionsNodeIdGet(requestParameters.nodeId, requestParameters.jobRunId, requestParameters.flowId, requestParameters.environment, requestParameters.fromStartTime, requestParameters.untilStartTime, requestParameters.afterDecisionId, requestParameters.beforeDecisionId, requestParameters.pageSize, requestParameters.sortDirection, requestParameters.statuses, requestParameters.acceptEncoding, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Write the manifest marker — flips a run\'s node-executions & node couts to \"ready\".
     * @summary Mark Node Executions Available
     * @param {NodeExecutionsApiMarkNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeExecutionsApi
     */
    public markNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPost(requestParameters: NodeExecutionsApiMarkNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPostRequest, options?: RawAxiosRequestConfig) {
        return NodeExecutionsApiFp(this.configuration).markNodeExecutionsAvailableHistoryApiV3JobRunsJobRunIdNodeExecutionsManifestPost(requestParameters.jobRunId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start the eager node-executions UNLOAD for a completed long running test run. It doesn\'t block the caller and the caller is responsible the poll for the result.
     * @summary Trigger Job Node Execution Generation
     * @param {NodeExecutionsApiTriggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeExecutionsApi
     */
    public triggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPost(requestParameters: NodeExecutionsApiTriggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPostRequest, options?: RawAxiosRequestConfig) {
        return NodeExecutionsApiFp(this.configuration).triggerJobNodeExecutionGenerationHistoryApiV3JobRunsJobRunIdNodeExecutionsPost(requestParameters.jobRunId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NodeResultsApi - axios parameter creator
 * @export
 */
export const NodeResultsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Node Result
         * @param {string} decisionId 
         * @param {string} nodeId 
         * @param {boolean} [iceberg] 
         * @param {string | null} [$fields] 
         * @param {string | null} [acceptEncoding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet: async (decisionId: string, nodeId: string, iceberg?: boolean, $fields?: string | null, acceptEncoding?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'decisionId' is not null or undefined
            assertParamExists('getNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet', 'decisionId', decisionId)
            // verify required parameter 'nodeId' is not null or undefined
            assertParamExists('getNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet', 'nodeId', nodeId)
            const localVarPath = `/history/api/v3/decisions/{decision_id}/node_results/{node_id}`
                .replace(`{${"decision_id"}}`, encodeURIComponent(String(decisionId)))
                .replace(`{${"node_id"}}`, encodeURIComponent(String(nodeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (iceberg !== undefined) {
                localVarQueryParameter['iceberg'] = iceberg;
            }

            if ($fields !== undefined) {
                localVarQueryParameter['$fields'] = $fields;
            }


    
            if (acceptEncoding != null) {
                localVarHeaderParameter['accept-encoding'] = String(acceptEncoding);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Node Results
         * @param {string} decisionId 
         * @param {string | null} [startingAfter] 
         * @param {string | null} [pageToken] 
         * @param {number} [pageSize] 
         * @param {boolean} [iceberg] 
         * @param {string | null} [$fields] 
         * @param {string | null} [types] 
         * @param {string | null} [names] 
         * @param {string | null} [acceptEncoding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet: async (decisionId: string, startingAfter?: string | null, pageToken?: string | null, pageSize?: number, iceberg?: boolean, $fields?: string | null, types?: string | null, names?: string | null, acceptEncoding?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'decisionId' is not null or undefined
            assertParamExists('listNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet', 'decisionId', decisionId)
            const localVarPath = `/history/api/v3/decisions/{decision_id}/node_results`
                .replace(`{${"decision_id"}}`, encodeURIComponent(String(decisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (startingAfter !== undefined) {
                localVarQueryParameter['starting_after'] = startingAfter;
            }

            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (iceberg !== undefined) {
                localVarQueryParameter['iceberg'] = iceberg;
            }

            if ($fields !== undefined) {
                localVarQueryParameter['$fields'] = $fields;
            }

            if (types !== undefined) {
                localVarQueryParameter['types'] = types;
            }

            if (names !== undefined) {
                localVarQueryParameter['names'] = names;
            }


    
            if (acceptEncoding != null) {
                localVarHeaderParameter['accept-encoding'] = String(acceptEncoding);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NodeResultsApi - functional programming interface
 * @export
 */
export const NodeResultsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NodeResultsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Node Result
         * @param {string} decisionId 
         * @param {string} nodeId 
         * @param {boolean} [iceberg] 
         * @param {string | null} [$fields] 
         * @param {string | null} [acceptEncoding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet(decisionId: string, nodeId: string, iceberg?: boolean, $fields?: string | null, acceptEncoding?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet(decisionId, nodeId, iceberg, $fields, acceptEncoding, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeResultsApi.getNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Node Results
         * @param {string} decisionId 
         * @param {string | null} [startingAfter] 
         * @param {string | null} [pageToken] 
         * @param {number} [pageSize] 
         * @param {boolean} [iceberg] 
         * @param {string | null} [$fields] 
         * @param {string | null} [types] 
         * @param {string | null} [names] 
         * @param {string | null} [acceptEncoding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet(decisionId: string, startingAfter?: string | null, pageToken?: string | null, pageSize?: number, iceberg?: boolean, $fields?: string | null, types?: string | null, names?: string | null, acceptEncoding?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NodeResultsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet(decisionId, startingAfter, pageToken, pageSize, iceberg, $fields, types, names, acceptEncoding, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NodeResultsApi.listNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NodeResultsApi - factory interface
 * @export
 */
export const NodeResultsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NodeResultsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Node Result
         * @param {NodeResultsApiGetNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet(requestParameters: NodeResultsApiGetNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet(requestParameters.decisionId, requestParameters.nodeId, requestParameters.iceberg, requestParameters.$fields, requestParameters.acceptEncoding, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Node Results
         * @param {NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet(requestParameters: NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<NodeResultsList> {
            return localVarFp.listNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet(requestParameters.decisionId, requestParameters.startingAfter, requestParameters.pageToken, requestParameters.pageSize, requestParameters.iceberg, requestParameters.$fields, requestParameters.types, requestParameters.names, requestParameters.acceptEncoding, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet operation in NodeResultsApi.
 * @export
 * @interface NodeResultsApiGetNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGetRequest
 */
export interface NodeResultsApiGetNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof NodeResultsApiGetNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet
     */
    readonly decisionId: string

    /**
     * 
     * @type {string}
     * @memberof NodeResultsApiGetNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet
     */
    readonly nodeId: string

    /**
     * 
     * @type {boolean}
     * @memberof NodeResultsApiGetNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet
     */
    readonly iceberg?: boolean

    /**
     * 
     * @type {string}
     * @memberof NodeResultsApiGetNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet
     */
    readonly $fields?: string | null

    /**
     * 
     * @type {string}
     * @memberof NodeResultsApiGetNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet
     */
    readonly acceptEncoding?: string | null
}

/**
 * Request parameters for listNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet operation in NodeResultsApi.
 * @export
 * @interface NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGetRequest
 */
export interface NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet
     */
    readonly decisionId: string

    /**
     * 
     * @type {string}
     * @memberof NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet
     */
    readonly startingAfter?: string | null

    /**
     * 
     * @type {string}
     * @memberof NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet
     */
    readonly pageToken?: string | null

    /**
     * 
     * @type {number}
     * @memberof NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {boolean}
     * @memberof NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet
     */
    readonly iceberg?: boolean

    /**
     * 
     * @type {string}
     * @memberof NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet
     */
    readonly $fields?: string | null

    /**
     * 
     * @type {string}
     * @memberof NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet
     */
    readonly types?: string | null

    /**
     * 
     * @type {string}
     * @memberof NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet
     */
    readonly names?: string | null

    /**
     * 
     * @type {string}
     * @memberof NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet
     */
    readonly acceptEncoding?: string | null
}

/**
 * NodeResultsApi - object-oriented interface
 * @export
 * @class NodeResultsApi
 * @extends {BaseAPI}
 */
export class NodeResultsApi extends BaseAPI {
    /**
     * 
     * @summary Get Node Result
     * @param {NodeResultsApiGetNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeResultsApi
     */
    public getNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet(requestParameters: NodeResultsApiGetNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGetRequest, options?: RawAxiosRequestConfig) {
        return NodeResultsApiFp(this.configuration).getNodeResultHistoryApiV3DecisionsDecisionIdNodeResultsNodeIdGet(requestParameters.decisionId, requestParameters.nodeId, requestParameters.iceberg, requestParameters.$fields, requestParameters.acceptEncoding, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Node Results
     * @param {NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NodeResultsApi
     */
    public listNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet(requestParameters: NodeResultsApiListNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGetRequest, options?: RawAxiosRequestConfig) {
        return NodeResultsApiFp(this.configuration).listNodeResultsHistoryApiV3DecisionsDecisionIdNodeResultsGet(requestParameters.decisionId, requestParameters.startingAfter, requestParameters.pageToken, requestParameters.pageSize, requestParameters.iceberg, requestParameters.$fields, requestParameters.types, requestParameters.names, requestParameters.acceptEncoding, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OutcomeReportsApi - axios parameter creator
 * @export
 */
export const OutcomeReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List Outcome Reports
         * @param {string} decisionId 
         * @param {string | null} [startingAfter] 
         * @param {string | null} [pageToken] 
         * @param {number} [pageSize] 
         * @param {string | null} [$fields] 
         * @param {string | null} [keys] 
         * @param {string | null} [acceptEncoding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet: async (decisionId: string, startingAfter?: string | null, pageToken?: string | null, pageSize?: number, $fields?: string | null, keys?: string | null, acceptEncoding?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'decisionId' is not null or undefined
            assertParamExists('listOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet', 'decisionId', decisionId)
            const localVarPath = `/history/api/v3/decisions/{decision_id}/outcome_reports`
                .replace(`{${"decision_id"}}`, encodeURIComponent(String(decisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Authorization required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)

            if (startingAfter !== undefined) {
                localVarQueryParameter['starting_after'] = startingAfter;
            }

            if (pageToken !== undefined) {
                localVarQueryParameter['page_token'] = pageToken;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if ($fields !== undefined) {
                localVarQueryParameter['$fields'] = $fields;
            }

            if (keys !== undefined) {
                localVarQueryParameter['keys'] = keys;
            }


    
            if (acceptEncoding != null) {
                localVarHeaderParameter['accept-encoding'] = String(acceptEncoding);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OutcomeReportsApi - functional programming interface
 * @export
 */
export const OutcomeReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OutcomeReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List Outcome Reports
         * @param {string} decisionId 
         * @param {string | null} [startingAfter] 
         * @param {string | null} [pageToken] 
         * @param {number} [pageSize] 
         * @param {string | null} [$fields] 
         * @param {string | null} [keys] 
         * @param {string | null} [acceptEncoding] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet(decisionId: string, startingAfter?: string | null, pageToken?: string | null, pageSize?: number, $fields?: string | null, keys?: string | null, acceptEncoding?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OutcomesList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet(decisionId, startingAfter, pageToken, pageSize, $fields, keys, acceptEncoding, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutcomeReportsApi.listOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OutcomeReportsApi - factory interface
 * @export
 */
export const OutcomeReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OutcomeReportsApiFp(configuration)
    return {
        /**
         * 
         * @summary List Outcome Reports
         * @param {OutcomeReportsApiListOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet(requestParameters: OutcomeReportsApiListOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OutcomesList> {
            return localVarFp.listOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet(requestParameters.decisionId, requestParameters.startingAfter, requestParameters.pageToken, requestParameters.pageSize, requestParameters.$fields, requestParameters.keys, requestParameters.acceptEncoding, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for listOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet operation in OutcomeReportsApi.
 * @export
 * @interface OutcomeReportsApiListOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGetRequest
 */
export interface OutcomeReportsApiListOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof OutcomeReportsApiListOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet
     */
    readonly decisionId: string

    /**
     * 
     * @type {string}
     * @memberof OutcomeReportsApiListOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet
     */
    readonly startingAfter?: string | null

    /**
     * 
     * @type {string}
     * @memberof OutcomeReportsApiListOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet
     */
    readonly pageToken?: string | null

    /**
     * 
     * @type {number}
     * @memberof OutcomeReportsApiListOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof OutcomeReportsApiListOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet
     */
    readonly $fields?: string | null

    /**
     * 
     * @type {string}
     * @memberof OutcomeReportsApiListOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet
     */
    readonly keys?: string | null

    /**
     * 
     * @type {string}
     * @memberof OutcomeReportsApiListOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet
     */
    readonly acceptEncoding?: string | null
}

/**
 * OutcomeReportsApi - object-oriented interface
 * @export
 * @class OutcomeReportsApi
 * @extends {BaseAPI}
 */
export class OutcomeReportsApi extends BaseAPI {
    /**
     * 
     * @summary List Outcome Reports
     * @param {OutcomeReportsApiListOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutcomeReportsApi
     */
    public listOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet(requestParameters: OutcomeReportsApiListOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGetRequest, options?: RawAxiosRequestConfig) {
        return OutcomeReportsApiFp(this.configuration).listOutcomeReportsHistoryApiV3DecisionsDecisionIdOutcomeReportsGet(requestParameters.decisionId, requestParameters.startingAfter, requestParameters.pageToken, requestParameters.pageSize, requestParameters.$fields, requestParameters.keys, requestParameters.acceptEncoding, options).then((request) => request(this.axios, this.basePath));
    }
}



